<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card tile>
          <v-card-title>{{
            $t("common." + (edition_mode ? "edit" : "add"))
          }}</v-card-title>
          <v-divider />
          <v-card-text>
            <v-form ref="form">
              <UserPicker
                required
                :readonly="true"
                role="MENTOR"
                v-model="formModel.user"
                :label="$t('user.select-mentor')"
              />
              <DatePicker
                required
                v-model="formModel.date"
                :label="$tc('common.date', 1)"
              />
              <v-textarea
                v-model="formModel.comment"
                :label="$t('diaries.comment')"
                required
                :rules="required_rule"
              />
              <v-textarea
                v-model="formModel.followup"
                :label="$t('diaries.followup')"
                required
                :rules="required_rule"
              />
            </v-form>
          </v-card-text>
          <v-divider class="mt-5"></v-divider>
          <v-card-actions>
            <v-btn text @click="$router.go(-1)">{{
              $t("common.cancel")
            }}</v-btn>
            <v-spacer />
            <v-btn tile color="primary" :loading="loading" @click="_submit">{{
              $t("common.save")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DatePicker from "@/components/form/DatePicker"
import { mapActions } from "vuex"
import { ADD, UPDATE, FETCH_ONE } from "@/store/action-types"
import FormMixin from "@/mixins/FormMixin"
import UserPicker from "@/components/form/UserPicker"

export default {
  name: "MentorDiaryForm",
  components: { UserPicker, DatePicker },
  mixins: [FormMixin],
  computed: {
    required_rule() {
      return [(v) => !!v || this.$t("errors.field_required")]
    },
    mentor_diary() {
      return this.$store.state.mentor_diary.data
    },
  },
  data() {
    return {
      selected_types: [],
      quantities: {},
      formModel: {
        user: {},
        date: null,
        types: [],
      },
    }
  },
  async mounted() {
    if (this.$route.params.diary_id) {
      this.edition_mode = true
      let self = this
      await this.FETCH_ONE(this.$route.params.diary_id)
        .then((data) => {
          self.$set(self, "formModel", data)
        })
        .finally(() => {
          self.loading = false
        })
    }
  },

  methods: {
    ...mapActions("mentor_diary", [FETCH_ONE, UPDATE, ADD]),

    _submit() {
      this.formModel.types = Object.keys(this.quantities).map((item) => {
        return { type_id: item, count: this.quantities[item] }
      })
      this.submit(
        ["id", "date", "comment", "followup", "user"],
        () => "/diary_mentor/",
        "user"
      )
    },
  },
}
</script>
